(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('MainController', MainController);

    MainController.$inject = [
        '$rootScope',
        'authorization',
        '$location',
        'scopes',
        'audioService',
        'userService',
        'chat',
        '$filter',
        'preferences',
		'genericDataService',
        'fleet',
        '$route',
        '$state',
        'common', 
        'restrictionService', 
        'logEmpleadosService', 
        '$window'
    ];

    /* jshint maxstatements:false, maxparams:false */
    function MainController(
        $rootScope,
        authorization,
        $location,
        scopes,
        audioService,
        userService,
        chat,
        $filter,
        preferences,
		genericDataService,
        fleet,
        $route,
        $state,
        common,
        restrictionService, 
        logEmpleadosService, 
        $window) {

        var vm = this;
        vm.lectura = restrictionService.lectura; 
        vm.disableButton = true; 
		vm.fleet = fleet;
        vm.chat = chat;
        vm.authService = authorization;
        vm.openLeftMenu = openLeftMenu;
        vm.logout = authorization.logout;
        vm.toggleFullscreen = toggleFullscreen;
        vm.audio = audioService;
        vm.perfilesFlota = [];
		vm.dropDownClicked = dropDownClicked;
		vm.updateConnexionEmpresaMaster = updateConnexionEmpresaMaster;
        vm.user = {
            name: null,
            surname: null
        };
        vm.goToOrdenNueva = goToOrdenNueva;
        vm.isActiveModule = isActiveModule;

        //estado desplegado secciones sidebar
        vm.activosClicked = true;
        vm.inactivosClicked = true;
        vm.isSidebarOpen = isSidebarOpen;
        vm.root = $rootScope;
        vm.preferences = preferences;
        //click events
        vm.menuClicked = false;
        vm.defaultIconClicked = false;
        vm.tab1 = true;

        //public functions
        vm.showHideFleetBar = showHideFleetBar;
        vm.connectDisconnectAseguradora = connectDisconnectAseguradora;
        vm.redirectControlHorario = redirectControlHorario; 

        vm.changeEstadoJornada = changeEstadoJornada;
        vm.redirectToHelp = redirectToHelp;

		//traslados amounts
		vm.newLogisticsCount = null;

        $rootScope.isActive = isActive;
        
        /* INITIALIZER */
		(function () {
            getUserData();
            loadCompanyPreferences();
            //$timeout(function() {$scope.$broadcast('rebuild:me');}, 1000);
            //linkWithMap(); //byArnau
        })();

        function linkWithMap() { //Link with map to share scopes for the fleet side bar
            var map = scopes.get('map');
            if (map != null) {
                vm.map = map;
                vm.map.main = vm;
            }
            scopes.store('main', vm);
        }


        function getUserData() {
            vm.user.name = userService.userData.name;
            vm.user.surname = userService.userData.surname;
            vm.user.estadoJornada = userService.userData.estadoJornada; 
            vm.user.estadoJornadaDescripcion = vm.user.estadoJornada == 0 ? 'Jornada iniciada' : vm.user.estadoJornada == 1 ? 'Jornada en pausa' : 'Jornada no iniciada'; 
            vm.disableButton = false; 
            vm.user.esSupervisor = userService.userData.esSupervisor; 
            vm.user.esAdmin = userService.userData.esAdmin; 
            genericDataService.getPerfilesDeFlotaPorUsuario()
                .then(function (res) {
                    vm.perfilesFlota = res;
				});
        }

        function changeEstadoJornada(val) {
            vm.disableButton = true; 
            logEmpleadosService.changeEstadoJornada(val)
                .then(function (res) {
                    if(res.data == true) {
                        userService.userData.estadoJornada = val == 2 ? 1 : val == 3 ? 2 : 0; 
                        vm.user.estadoJornada = userService.userData.estadoJornada;
                        vm.user.estadoJornadaDescripcion = vm.user.estadoJornada == 0 ? 'Jornada iniciada' : vm.user.estadoJornada == 1 ? 'Jornada en pausa' : 'Jornada no iniciada';
                    }
                    vm.disableButton = false; 
                });
        }

        function toggleFullscreen() {
            /*jshint maxcomplexity:false */
            if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                    document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                    document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        }

        function openLeftMenu() {

        }

         function redirectToHelp() {
            $window.open('https://investeltechnologies.com/soporte/', '_blank'); 
         }

        function dropDownClicked(event) {

            angular.forEach(document.getElementsByTagName('ul'), function (elem) {
                elem.className = '';
            });
            var elementUl = event.target;
            while (elementUl !== null && elementUl.tagName.toLowerCase() !== 'ul') {
                elementUl = elementUl.nextElementSibling;
            }
            angular.element(elementUl).addClass('ulOpen');

        }

        function isActive(route) {
            return $location.path() === route;
        }

        function showHideFleetBar() {
            $rootScope.sidebarOpen = !$rootScope.sidebarOpen;
            $rootScope.$broadcast('detail-resize');
        }

        function isSidebarOpen() {
            return $rootScope.sidebarOpen;
        }

        function loadCompanyPreferences() {
            if (!preferences.loaded) {
                preferences.getCompanyPrefs();
            }
		}

		function connectDisconnectAseguradora(aseguradora) {
			var aseguradoraToSend = {
				'asegId': aseguradora.asegId,
				'insurerName': aseguradora.insurerName,
				'state': !aseguradora.state,
				'editable': aseguradora.editable,
				'color': aseguradora.color
			};
			fleet.updateAseguradorasConnexion(aseguradoraToSend);
		}

		function updateConnexionEmpresaMaster() {
			fleet.updateConnexionEmpresaMaster();
        }

        function redirectControlHorario(type) {
            if(userService.userData.empresamaster.contrataControlHorario == true) {
                if(type == 0) {
                    $state.go('flota.controlHorario.fichajes');
                }
                else if(type == 1){
                    $state.go('flota.guardias'); 
                }
                else if(type == 2){
                    $state.go('flota.misfichajes');
                }
            }
            else {
                $state.go('flota.controlHorario.activarControlHorario'); 

            }
        }

        function goToOrdenNueva() {
            $rootScope.tabManager.goToOrdenes(null);
        }

        function isActiveModule(startsWith) {
            if (common.isNullOrUndefined($state) || common.isNullOrUndefined($state.current) || $state.current.name.length == 0)
                return false;

            if (Array.isArray(startsWith)) {
                for (var i = 0; i < startsWith.length; i++) {
                    if ($state.current.name.startsWith(startsWith[i]))
                        return true;
                }
            } else {
                return $state.current.name.startsWith(startsWith);
            }
        }
    }
})();